// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"6fe7b3ec9b40eea6a819","243":"b9e49f0c4364bb5ead67","682":"42decabe499554162257","688":"737e092698e2fc7ab5de","738":"c0ac956aada0f33ce73f","765":"85e2cb3a12e4732aa483","852":"404b6b20314178dda6da"}[chunkId] + ".bundle.js";
};